export enum EDGES_TYPE {
  EAVE,
  RIDGE,
  RAKEGABLE,
}
